import javaFullStack from '../assets/certificados/2021-java-full-stack.png'
import javaInicial from '../assets/certificados/2021-java-inicial.png'
import poo from '../assets/certificados/2021-poo.png'
import hibernateJpa from '../assets/certificados/2023-hibernate-jpa.jpg'
import lenguajeJava from '../assets/certificados/2023-lenguaje-java.jpg'
import programacionFuncional from '../assets/certificados/2023-programacion-funciona-java.jpg'
import reactNode from '../assets/certificados/2023-react-node.png'
import spring from '../assets/certificados/2023-spring-springboot.jpg'
import microfrontend from '../assets/certificados/2024-microfrontend.png'
import react from '../assets/certificados/2024-react.png'

const cursosData = [
    {
        id: 19, 
        img: null,
        academy: 'Ayi Academy', 
        year: '2023',
        title: {
            es: 'Inglés',
            en: 'English',
        }, 
        description: {
            es: 'En el 2023 rendí con éxito un examen de nivel C2 para validar mis conocimientos en Inglés. Los mismos son producto de mis estudios, así como de un año viviendo en Nueva Zelanda. Esto me permitió, entre muchas otras cosas, trabajar 5 años como docente de inglés en un colegio bilingüe.',
            en: 'In 2023, I successfully passed a C2 level exam to validate my English proficiency. These skills are a result of my studies as well as one year living in New Zealand. This experience allowed me, among many other things, to work for 5 years as an English teacher in a bilingual school.'
        },
    },
    {
        id: 20, 
        img: null,
        academy: 'UTN', 
        year: '2024',
        title: {
            es: 'Associte Degree in IT',
            en: 'Tecnicatura en IT',
        }, 
        description: {
            es: 'In 2024, I enrolled in the National Technological University to expand my foundational knowledge in information technology.',
            en: 'En el 2024 ingresé a la Universidad Tecnológica Nacional para ampliar mis conocimientos de base en tecnologías de la información.'
        },
    },
    {
        id: 21, 
        img: microfrontend,
        academy: 'Udemy', 
        year: '2023',
        title: {
            es: 'Microfrontend',
            en: 'Microfrontend',
        }, 
        description: {
            es: 'Curso que aborda la construcción de sitios web enmarcados dentro de la arquitectura microfrontend.',
            en: 'Course covering microfrontend architecture for website development.'
        },
    },
    {
        id: 22, 
        img: react,
        academy: 'Udemy', 
        year: '2023',
        title: {
            es: 'React Avanzado',
            en: 'React Advanced',
        }, 
        description: {
            es: 'Curso completo de React de 60hs que incluye Context, Redux asi como Vite, Next, CreateReactApp entre otros varios frameworks y librerias populares en el desarrollo web.',
            en: 'Comprehensive 60-hour React Course covering Context, Redux, as well as Vite, Next.js, Create React App, and various other popular frameworks and libraries in web development.'
        },
    },
    {
        id: 23, 
        img: programacionFuncional,
        academy: 'Udemy', 
        year: '2022',
        title: {
            es: 'Programación Funcional Java',
            en: 'Functional Programming in Java',
        }, 
        description: {
            es: 'Curso que abordó los fundamentos de la programación funcional en Java.',
            en: 'Course covering fundamentals of functional programming in Java.'
        },
    },
    {
        id: 24, 
        img: hibernateJpa,
        academy: 'Udemy', 
        year: '2022',
        title: {
            es: 'Hibernate & JPA',
            en: 'Hibernate & JPA',
        }, 
        description: {
            es: 'Curso completo para incorporar las tecnologías mencionadas.',
            en: 'Comprehensive course for incorporating mentioned technologies.'
        },
    },
    {
        id: 25, 
        img: spring,
        academy: 'Udemy', 
        year: '2022',
        title: {
            es: 'Spring & Springboot',
            en: 'Spring & Springboot',
        }, 
        description: {
            es: 'Curso completo para incorporar las tecnologías mencionadas.',
            en: 'Comprehensive course for incorporating mentioned technologies.'
        },
    },
    {
        id: 26, 
        img: lenguajeJava,
        academy: 'Udemy', 
        year: '20233',
        title: {
            es: 'Lenguaje Java',
            en: 'Lenguaje Java',
        }, 
        description: {
            es: 'Especialización en Lenguaje Java.',
            en: 'Specialization in Java Language.'
        },
    },
    {
        id: 27, 
        img: reactNode,
        academy: 'Ayi Academy', 
        year: '2022',
        title: {
            es: 'React & Node',
            en: 'React & Node',
        }, 
        description: {
            es: 'Curso de entrada que abordaba ambos lenguajes asi como la contrucción de un sitio utilizando el stack MERN.',
            en: 'Introductory course covering both languages and building a website using the MERN Stack.'
        },
    },
    {
        id: 28, 
        img: javaFullStack,
        academy: 'Codo a Codo', 
        year: '2021',
        title: {
            es: 'Java FullStack',
            en: 'Java FullStack',
        }, 
        description: {
            es: 'Curso semestral que abordó HTML, CSS, JS, VueJs, MySQL y JAVA.',
            en: 'Semester-long Course Covering HTML, CSS, JavaScript, Vue.js, MySQL, and Java.'
        },
    },
    {
        id: 29, 
        img: poo,
        academy: 'Educación IT', 
        year: '2021',
        title: {
            es: 'Programación Orientada a Objetos',
            en: 'Object-Oriented Programming',
        }, 
        description: {
            es: 'Curso corto para comprender los fundamentos del paradingma de la programación orientada a objetos.',
            en: 'Short Course to Understand the Fundamentals of Object-Oriented Programming Paradigm.'
        },
    },
    {
        id: 30, 
        img: javaInicial,
        academy: 'Educación IT', 
        year: '2021',
        title: {
            es: 'Java Inicial',
            en: 'Java Beginners',
        }, 
        description: {
            es: 'Curso introductorio de lenguaje Java.',
            en: 'Introductory Course to Java Programming Language.'
        },
    },
]

export default cursosData